import React, { useMemo } from "react";
import {
    IPageData,
    ModularConfigurator,
} from "tsi-common-react/src/apps/configurator/ModularConfigurator/index";
import { ModularConfiguratorOptionSet } from "tsi-common-react/src/apps/configurator/models";
import { prefillSSRStoreData } from "tsi-common-react/src/apps/configurator/ssr";
import { ChatLink } from "tsi-common-react/src/components/ChatLink/index";
import { check } from "tsi-common-react/src/models/utils";
import { useSSRStorePrefill } from "tsi-common-react/src/store/reducers";
import { usePageURL } from "tsi-common-react/src/utils/urls";
import { t } from "ttag";

import { templates } from "@reactivated";

const ChatLinkWrapper = (): React.ReactElement => {
    const contactUsForm = usePageURL("contact_us_form");
    const home = usePageURL("home");
    return (
        <ChatLink
            className={"button"}
            chatOnlineText={t`Chat`}
            chatOfflineLink={contactUsForm || home}
        />
    ) as React.ReactElement;
};

export const Template = (props: templates.ModularConfiguratorTemplate) => {
    const pageData: IPageData = JSON.parse(props.page_data);
    const isAlternativeDesign = pageData.design === "alt";

    // Parse configurator option set
    const optionSet = useMemo(
        () =>
            check(
                ModularConfiguratorOptionSet.decode(
                    JSON.parse(props.configurator_init_data),
                ),
            ),
        [props.configurator_init_data],
    );

    // Hydrate Redux store with SSR data before render
    useSSRStorePrefill(
        {
            products_data: props.products_data,
            product_class_data: props.product_class_data,
            financing_plans_data: props.financing_plans_data,
            concrete_bundles_data: props.concrete_bundles_data,
            upsell_info_modals_data: props.upsell_info_modals_data,
            promo_cards_data: props.promo_cards_data,
            reviews_products_data: props.reviews_products_data,
            initial_variant_id: optionSet.initial_variant_id,
            product_ids: optionSet.product_ids,
        },
        prefillSSRStoreData,
    );

    return (
        <ModularConfigurator
            {...props}
            siteProps={{
                buttonColor: "primary-congress-blue",
                showFeelScale: true,
                strikeThroughMSRP: true,
                isPlpPanelStyle: isAlternativeDesign,
                useCompareDrawerCenter: true,
                chatLinkComponent: isAlternativeDesign ? (
                    <ChatLinkWrapper />
                ) : null,
            }}
        />
    );
};
